import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'html:img': () => import('./components/image')
    }
});
